// @ts-nocheck
/**
 * This file contains the deserializers object that maps version names to the deserializers functions
 * It can be executed with node.js
 * in the future this file can be unit tested in order to make more robust the serializers
 */
import v0_0_5 from './v0_0_5/VersionInfo';
import v0_0_6 from './v0_0_6/VersionInfo';
import v0_0_7 from './v0_0_7/VersionInfo';
import v0_0_8 from './v0_0_8/VersionInfo';
import v0_0_9 from './v0_0_9/VersionInfo';
import v0_0_10 from './v0_0_10/VersionInfo';
import v0_0_11 from './v0_0_11/VersionInfo';
import v0_0_12 from './v0_0_12/VersionInfo';
import v0_0_13 from './v0_0_13/VersionInfo';
import v0_0_14 from './v0_0_14/VersionInfo';
import type { SerializerRegistry, VersionDescriptor } from '@visualizer/types';

const versions: SerializerRegistry[] = [v0_0_5, v0_0_6, v0_0_7, v0_0_8, v0_0_9, v0_0_10, v0_0_11, v0_0_12, v0_0_13, v0_0_14];

const deserializers = versions.reduce<Record<string, VersionDescriptor>>((acc, versionInfo, index) => {
    acc[versionInfo.version] = {
        ...versionInfo,
        previous: index > 0 ? versions[index - 1].version : null,
    };
    return acc;
}, {});

export default deserializers;
